/**
 * Legacy Data Cleanup Utilities
 *
 * Issue #1049 Phase 4
 *
 * 過去のモック実装で使用していたデータをクリーンアップする。
 */

/**
 * Legacy AI Profile Cache Cleanup
 *
 * mockAIServiceで使用していたlocalStorageキャッシュを削除する。
 * Phase 1-3でBackend Redis Cacheに移行したため、localStorageは不要。
 *
 * キー形式: ai_profile_{customerId}
 */
export const cleanupLegacyAIProfileCache = (): void => {
  // SSR対応: localStorageが存在しない場合はスキップ
  if (typeof localStorage === 'undefined') {
    return;
  }

  const keysToRemove: string[] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('ai_profile_')) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));

  if (keysToRemove.length > 0) {
    console.log(
      `[LegacyCleanup] Removed ${keysToRemove.length} legacy AI profile cache entries`
    );
  }
};

/**
 * Run all legacy cleanup tasks
 *
 * アプリ起動時に一度だけ呼び出す。
 */
export const runLegacyCleanup = (): void => {
  cleanupLegacyAIProfileCache();
};
